import { CronHistoryPanel } from './CronHistoryPanel';

/**
 * Standalone page for System & Developer Tools > Cron History.
 *
 * The same panel also appears inside Settings; this wrapper just gives it a page shell so it can be
 * reached directly from the sidebar (and deep-linked) instead of only by digging through Settings.
 * Access is enforced in three places that agree: the sidebar entry is `adminOnly`, the panel itself
 * refuses non-admins, and `/v1/cron-monitor` is `@Roles('SUPER_ADMIN','ADMIN')`.
 */
export function CronHistoryPage() {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      <CronHistoryPanel />
    </div>
  );
}
